<div class="modal-header">
  <h5 class="modal-title">
    <span class="modal-title-icon is-chat" aria-hidden="true"></span>
    Miembros de la sala
  </h5>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body">
  <ul class="member-list">
    @for (member of members; track member.IdUser) {
    <li class="member-item">
      <span class="member-name">
        <span class="presence-dot" [class.online]="chatRealtimeService.isOnline(member.IdUser)" aria-hidden="true"></span>
        {{ member.Role ? member.Role + ' - ' : '' }}{{ member.Name }}
        @if (member.IsAdmin) {
        <span class="member-admin-tag">(admin)</span>
        }
      </span>
      @if (isAdmin && !member.IsMe) {
      <button type="button" class="btn-remove-member" title="Quitar de la sala" (click)="removeMember(member)">
        <span class="btn-icon-close" aria-hidden="true"></span>
      </button>
      }
    </li>
    }
  </ul>

  @if (isAdmin) {
  <div class="add-members mt-3">
    <label class="form-label">Añadir usuarios</label>
    <div class="d-flex gap-2">
      <select2 class="flex-grow-1" [multiple]="true" [data]="userSelectData" [(ngModel)]="selectedUserIdsToAdd" [disabled]="adding" placeholder="Selecciona usuarios"></select2>
      <button type="button" class="btn-lead" [disabled]="selectedUserIdsToAdd.length === 0 || adding" (click)="addSelected()">{{ adding ? 'Añadiendo...' : 'Añadir' }}</button>
    </div>
    <div class="form-check mt-2">
      <input type="checkbox" class="form-check-input" id="includeHistoryCheck" [(ngModel)]="includeHistory">
      <label class="form-check-label" for="includeHistoryCheck">Compartir historial de la conversación con los nuevos miembros</label>
    </div>
  </div>
  } @else {
  <p class="text-muted small mt-3">
    Solo el administrador de la sala
    @if (adminName) {
    ({{ adminName }})
    }
    puede gestionar los miembros.
  </p>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn-outline-black" (click)="close()">Cerrar</button>
</div>
